<template>
    <SbsBaseAvatar
        class="sbs-avatar"
        v-bind="baseAvatarData" />
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { isValueConvertedToNumber } from '../../utils/validators.js';
import { AllColors } from '../../utils/colors.js';

/**
 * Компонент аватара для проекта sbs-general.
 * Выводит либо изображение, либо инициалы пользователя
 */
export default {
    name: 'SbsAvatar',
    mixins: [themesMixin],
    computed: {
        initialsName() {
            const fullNameArray = this.name.split(' ');
            const firstCharsets = fullNameArray
                .map(item => item[0])
                .filter(i => i);

            return firstCharsets.slice(0, 2).join('');
        },
        baseAvatarData() {
            return {
                ...this.$attrs,
                ...this.themeData,
                backgroundTheme: this.backgroundTheme,
                colorTheme: this.colorTheme,
                imageSrc: this.imageSrc,
                size: this.size,
                text: this.initialsName,
            };
        },
    },
    inheritAttrs: false,
    props: {
        /**
         * Тема (цветовые решения) для цвета фона
         */
        backgroundTheme: {
            type: String,
            default: AllColors.PRIMARY,
        },
        /**
         * Тема (цветовые решения) для цвета текста
         */
        colorTheme: {
            type: String,
            default: AllColors.WHITE,
        },
        /**
         * Путь для изображения
         */
        imageSrc: {
            type: String,
            default: '',
        },
        /**
         * Фамилия и имя
         */
        name: {
            type: String,
            default: '',
        },
        /**
         * Размер, устанавливает значение для ширины и высоты сразу
         */
        size: {
            type: [String, Number],
            default: 42,
            validator: isValueConvertedToNumber,
        },
    },
};
</script>

<style lang="scss">
.sbs-avatar {
    text-transform: uppercase;
}
</style>
